module.exports = __webpack_public_path__ + "media/icons/re_white30-21ebf2d4.png";